import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// On an expired access token, silently refresh once and retry the request.
api.interceptors.response.use(null, async (error) => {
  const config = error.config;
  if (config && !config.__retried && error.response?.status === 401 && !config.url.includes('/auth/')) {
    config.__retried = true;
    try {
      await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
      return api(config);
    } catch {
      // refresh failed — fall through to the original error
    }
  }
  return Promise.reject(error);
});

// Map FastAPI error details (string or 422 array) to a readable message.
export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

// Uploaded images are stored on the backend; resolve relative paths.
export function resolveImage(url) {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
